import React from "react";
import clsx from "clsx";

import { CATEGORY_ALIAS } from "../../../types/talk";

import { SERVICE_TEMPLATE_ID } from "../../../consts/serviceTemplate";

import { UserServiceResponse } from "../../../services/userServiceServices";
import { TalkCategory } from "../../../services/talkServices";

type Props = {
  service?: UserServiceResponse;
  className?: string;
  categoryList?: TalkCategory[];
};

export default function ServiceBadge({
  service,
  className,
  categoryList,
}: Props) {
  return (
    <>
      {!service?.serviceId ? (
        <div
          className={clsx([
            "bg-brand-neutral-40 rounded-full text-xs px-2 font-semibold text-white",
            className,
          ])}
        >
          미적용
        </div>
      ) : service.serviceStatus === "only-occupant" ? (
        <div
          className={clsx([
            "bg-[#1fd7a1] rounded-full text-xs px-2 font-semibold text-white",
            className,
          ])}
        >
          입주사 전용
        </div>
      ) : service?.needAuthorized === true ? (
        <div
          className={clsx([
            "bg-[#1fd7a1] rounded-full text-xs px-2 font-semibold text-white",
            className,
          ])}
        >
          인증 필요
        </div>
      ) : categoryList &&
        service.serviceTemplateId === SERVICE_TEMPLATE_ID.BUILDING_MENU &&
        !categoryList.find(
          (item) => item.alias === CATEGORY_ALIAS.BUILDING_MENU
        ) ? (
        <div
          className={clsx([
            "bg-brand-neutral-40 rounded-full text-xs px-2 font-semibold text-white",
            className,
          ])}
        >
          건물 미지원
        </div>
      ) : null}
    </>
  );
}
